import { render, staticRenderFns } from "./utilisateur-avatar.vue?vue&type=template&id=0c0879ae"
import script from "./utilisateur-avatar.vue?vue&type=script&lang=js"
export * from "./utilisateur-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports